import { useMutation } from '@tanstack/react-query';
import { post } from '@/shared/api/api-client';
import type { CancelRecurringRequest } from '@/types/scheduling-api';

/**
 * POST /api/Appointment/CancelRecurring — cancel one occurrence,
 * "this and following", or the whole series of a recurring appointment.
 *
 * Body shape:
 *   {
 *     recurringId: string,
 *     cancellationReason: AppointmentCancellationReason,
 *     allAppointment: boolean,            // true → cancel entire series
 *     appointmentDate?: string,           // for "this only" / "following"
 *   }
 *
 * Mirrors Flutter `scheduling_data_source_impl.dart:1033`.
 */
export function useCancelRecurringAppointment() {
  return useMutation({
    mutationFn: (request: CancelRecurringRequest) =>
      post<void>('/api/Appointment/CancelRecurring', request),
  });
}
